import { Form, Input } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import AppModal from '@pages/inside/tenant/AppModal';
import { Button } from '@components/ui/Button';
import { CreateRoleModalBody, CreateRoleModalFooter } from '@pages/inside/tenant/style';

export default function InviteTenantModal({
    open,
    onClose,
    form,
    onSubmit,
    pending,
    permissionDenied,
}) {
    return (
        <AppModal
            title="Invite collaborator company"
            open={open}
            onCancel={onClose}
            footer={null}
            destroyOnClose
        >
            <Form form={form} layout="vertical" onFinish={onSubmit}>
                <CreateRoleModalBody>
                    <Form.Item
                        name="tenantId"
                        label="Tenant / company ID"
                        rules={[{ required: true, message: 'Enter the tenant or company id to invite' }]}
                    >
                        <Input placeholder="Tenant UUID from the partner company" autoComplete="off" />
                    </Form.Item>
                </CreateRoleModalBody>
                <CreateRoleModalFooter>
                    <Button type="button" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        $primary
                        $blackOnLight
                        icon={<TeamOutlined />}
                        loading={pending}
                        permissionDenied={permissionDenied}
                    >
                        Send invite
                    </Button>
                </CreateRoleModalFooter>
            </Form>
        </AppModal>
    );
}
